module.exports = __webpack_public_path__ + "img/bb.de482026.png";